<template>
  <div class="admin-layout">
    <!-- 顶部导航栏 -->
    <div class="admin-header">
      <div class="header-left">
        <h1 class="title">安全设备管理系统</h1>
        <span class="subtitle">管理员后台</span>
      </div>
      <div class="header-right">
        <el-dropdown @command="handleCommand">
          <span class="admin-info">
            <i class="el-icon-user-solid"></i>
            <span>{{ adminInfo.realName || 'Admin' }}</span>
            <i class="el-icon-arrow-down"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="profile">个人信息</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <div class="admin-body">
      <!-- 左侧边栏 -->
      <div class="admin-sidebar">
        <el-menu
          :default-active="activeMenu"
          class="sidebar-menu"
          @select="handleMenuSelect"
          :collapse="false"
        >
          <el-menu-item index="dashboard">
            <i class="el-icon-monitor"></i>
            <template #title>首页</template>
          </el-menu-item>
          
          <el-menu-item index="devices">
            <i class="el-icon-mobile-phone"></i>
            <template #title>设备管理</template>
          </el-menu-item>
          
          <el-menu-item index="families">
            <i class="el-icon-house"></i>
            <template #title>家庭管理</template>
          </el-menu-item>
          
          <el-menu-item index="products">
            <i class="el-icon-box"></i>
            <template #title>产品管理</template>
          </el-menu-item>
          
          <el-menu-item index="device-types">
            <i class="el-icon-setting"></i>
            <template #title>设备类型管理</template>
          </el-menu-item>
        </el-menu>
      </div>

      <!-- 主要内容区域 -->
      <div class="admin-content">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout',
  data() {
    return {
      adminInfo: {}
    }
  },
  computed: {
    activeMenu() {
      const path = this.$route.path
      // 处理子路径，返回相应的主菜单项
      if (path.startsWith('/admin/families')) {
        return 'families'
      } else if (path.startsWith('/admin/devices')) {
        return 'devices'
      } else if (path.startsWith('/admin/dashboard')) {
        return 'dashboard'
      } else if (path.startsWith('/admin/products')) {
        return 'products'
      } else if (path.startsWith('/admin/device-types')) {
        return 'device-types'
      }
      // 如果是admin根路径，默认为dashboard
      if (path === '/admin' || path === '/admin/') {
        return 'dashboard'
      }
      return 'dashboard'
    }
  },
  created() {
    this.loadAdminInfo()
  },
  methods: {
    loadAdminInfo() {
      // 从localStorage获取管理员信息
      const adminUser = localStorage.getItem('adminUser')
      if (adminUser) {
        this.adminInfo = JSON.parse(adminUser)
      }
    },

    handleMenuSelect(index) {
      // 手动处理菜单选择，避免与动态路由冲突
      const menuRoutes = {
        'dashboard': '/admin/dashboard',
        'devices': '/admin/devices',
        'families': '/admin/families',
        'products': '/admin/products',
        'device-types': '/admin/device-types'
      }
      
      const targetRoute = menuRoutes[index]
      if (targetRoute && this.$route.path !== targetRoute) {
        // 如果当前不在目标路由，则跳转
        this.$router.push(targetRoute)
      }
    },

    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.showProfile()
          break
        case 'logout':
          this.logout()
          break
      }
    },

    showProfile() {
      // 显示个人信息对话框
      this.$message.info('个人信息功能待实现')
    },

    logout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除登录信息
        localStorage.removeItem('adminUser')
        localStorage.removeItem('userRole')
        
        this.$message.success('已退出登录')
        this.$router.push('/admin/login')
      }).catch(() => {
        // 用户取消
      })
    }
  }
}
</script>

<style scoped>
.admin-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.admin-header {
  height: 60px;
  background: #ffffff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.subtitle {
  font-size: 14px;
  color: #666;
  background: #f0f2f5;
  padding: 4px 8px;
  border-radius: 4px;
}

.header-right {
  display: flex;
  align-items: center;
}

.admin-info {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  color: #333;
  transition: background-color 0.3s;
}

.admin-info:hover {
  background: #f0f2f5;
}

/* 主体部分 */
.admin-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* 左侧边栏 */
.admin-sidebar {
  width: 200px;
  background: #ffffff;
  border-right: 1px solid #e6e6e6;
  overflow-y: auto;
}

.sidebar-menu {
  border: none;
  background: #ffffff;
}

.sidebar-menu .el-menu-item {
  color: #333333;
  border-radius: 6px;
  margin: 4px 8px;
}

.sidebar-menu .el-menu-item:hover {
  background: #f0f2f5;
  color: #1890ff;
}

.sidebar-menu .el-menu-item.is-active {
  background: #e6f7ff;
  color: #1890ff;
  border-right: 3px solid #1890ff;
}

.sidebar-menu .el-menu-item i {
  color: inherit;
  margin-right: 8px;
}

/* 主要内容区域 */
.admin-content {
  flex: 1;
  background: #f0f2f5;
  overflow-y: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-sidebar {
    width: 60px;
  }
  
  .sidebar-menu {
    width: 60px;
  }
  
  .admin-content {
    padding: 10px;
  }
  
  .header-left .subtitle {
    display: none;
  }
  
  .title {
    font-size: 16px;
  }
}
</style>